import React from 'react';

function VisitSitePin() {
  return <img src='/visitSitePin.svg' alt='Pin' />;
}

export default VisitSitePin;
